// extracted by mini-css-extract-plugin
export default {"buttonContainer":"Jwqz5","alignToEdge":"G8Izz","buttonIcon":"-tLOI","buttonCaption":"m5ppP","buttonSpacer":"fKwpX"};